module.exports = __webpack_public_path__ + "static/img/help_05intro_01.2f5e4a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stufdback/help_05intro_01.png
// module id = 720
// module chunks = 140